import React, { useEffect } from "react"
import { graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import parse from "html-react-parser"
import LeaderBoardAdSlot from "../components/LeaderBoardAdSlot"
import Layout from "../components/Layout"
import Seo from "../components/Seo"
import VideoPlayer from "../components/VideoPlayer"
import LargeRectangleAdSlot from "../components/LargeRectangleAdSlot"
import ViAdsSlot from "../components/viAdsSlot"
import NetpointTopbanner from "../components/AdUnits/netpoint/NetpointTopbanner"
import VideoSlider from "../components/VideoSlider"
import NetpointRectangle from "../components/AdUnits/netpoint/NetpointRectangle"
import NetpointOutstream from "../components/AdUnits/netpoint/NetpointOutstream"
import BelowArticleThumbnails from "../components/AdUnits/Taboola/BelowArticleThumbnails"

import {
  EmailShareButton,
  FacebookShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share"

const BlogPostTemplate = ({ data: { post } }) => {
  const url = typeof window !== "undefined" ? window.location.href : ""

  var postHead = null
  let lang = null

  if (typeof window !== "undefined") {
    lang = localStorage.getItem("notorious-language")

    if (!lang) {
      window.localStorage.setItem("notorious-language", "EN") //set english as default
      lang = "EN"
    }
  }

  var postContent = post.content

  var postTitle = post.title
  var postExcerpt = post.excerpt
  var postDate = post.date

  if (post.video.videoId != null) {
    postHead = <VideoPlayer videoId={post.video.videoId} />
  }

  let scrolled = false

  const categories =
    post.categories.nodes.length > 2
      ? post.categories.nodes.slice(0, 2)
      : post.categories.nodes

  const featuredImage = {
    data: post.featuredImage?.node?.localFile?.childImageSharp?.gatsbyImageData,
    alt: post.featuredImage?.node?.alt || ``,
  }

  const handleClick = () => {
    window.location.replace("/search?text=test")
  }

  useEffect(() => {
    // if (window._taboola) {
    //   console.log("taboola loaded")
    //   window._taboola.push({ notify: "newPageLoad" })
    //   window._taboola.push({
    //     article: "auto",
    //     url: typeof window !== "undefined" ? window.location.href : "",
    //   })
    //   window._taboola.push({
    //     mode: "alternating-thumbnails-a",
    //     container: "taboola-below-article-thumbnails",
    //     placement: "Below Article Thumbnails",
    //     target_type: "mix",
    //   })
    // }

    // Store language setting
    document.addEventListener("lang-de", e => {
      //check if post has DE version either in top level or translations array
      if (post.translations && post.translations.length > 0) {
        let de = post.translations.find(t => t.language.code === "DE")
        if (de) {
          window.location.href = "/de" + de.uri
        }
      }
    })

    document.addEventListener(
      "lang-en",
      e => {
        if (post.translations && post.translations.length > 0) {
          let en = post.translations.find(t => t.language.code === "EN")
          if (en) {
            window.location.href = en.uri
          }
        }
      },
      false
    )

    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 250)

    if (window.Cookiebot && window.Cookiebot.userCountry) {
      let loc = window.Cookiebot.userCountry

      if (loc != "at") {
        try {
          document.getElementById(
            "360vidDiv"
          ).innerHTML = ` <div style={{ height: "200px" }}>
          <script src="https://360playvid.info/slidepleer/s1011s.js"></script>
        </div>
          `
        } catch (error) {
          console.log("🚀 ~ file: blog-post.js:106 ~ useEffect ~ error:", error)
        }
      } else {
        console.log("Country is AT, skipping 360play vid media")
      }
    }

    const handleScroll = () => {
      const featuredVideoElement = document.getElementById("featured-video")
      var scrollTop = window.scrollY || document.documentElement.scrollTop

      // Log the scroll distance
      console.log("Page scrolled by", scrollTop, "pixels")

      if (scrollTop > 400) {
        if (featuredVideoElement) {
          if (!scrolled) {
            featuredVideoElement.classList.add("is-sticky")
            scrolled = true
          }
        }
      }

      if (window.scrollY === 0) {
        featuredVideoElement.classList.remove("is-sticky")
        scrolled = false
      }
    }

    if (window.Cookiebot && window.Cookiebot.userCountry) {
      let loc = window.Cookiebot.userCountry
      if (loc !== "at") {
        console.log("🚀 ~ file: blog-post.js:130 ~ useEffect ~ loc:", loc)
        // Sticky Video
        if (window && post.video.videoId != null) {
          window.addEventListener("scroll", handleScroll)
        }

        return () => {
          window.removeEventListener("scroll", handleScroll)
        }
      }
    }
  })

  return (
    <Layout>
      <Seo
        title={postTitle}
        description={postExcerpt}
        featuredImage={featuredImage}
      />

      <div className="main-article-content">
        <div className="section-article">
          <article>
            {/* <NetpointTopbanner /> */}
            <h1>{parse(postTitle)}</h1>
            <div className="d-flex align-items-center my-2">
              {categories.map(cat => (
                <a
                  href={cat.uri}
                  key={cat.uri}
                  className="btn btn-sm btn-light border-black rounded-5 my-2 "
                  style={{ marginRight: 10 + "px" }}
                >
                  {cat.name}
                </a>
              ))}
              <span className="d-block my-2">{postDate}</span>
            </div>
            {postHead ? (
              postHead
            ) : (
              <>
                <GatsbyImage
                  image={featuredImage.data}
                  alt={featuredImage.alt}
                  style={{ marginBottom: 50 }}
                />
              </>
            )}

            <LeaderBoardAdSlot />
            <ViAdsSlot />
            {parse(postContent)}

            <br />
            {/* <NetpointOutstream /> */}
            <div className="d-flex align-items-cennter mt-5 gap-3">
              <p style={{ marginTop: "1.7rem" }}>SHARE</p>

              <FacebookShareButton url={url} quote={postExcerpt}>
                <i className="bi bi-facebook text-black fs-3"></i>
              </FacebookShareButton>
              <TwitterShareButton url={url} title={postTitle}>
                <i className="bi bi-twitter text-black fs-3"></i>
              </TwitterShareButton>
              <EmailShareButton
                url={url}
                body={postExcerpt}
                subject={postTitle}
              >
                <i className="bi bi-envelope text-black fs-3"></i>
              </EmailShareButton>
              <WhatsappShareButton url={url} title={postTitle}>
                <i className="bi bi-whatsapp text-black fs-3"></i>
              </WhatsappShareButton>
              <TelegramShareButton url={url} title={postTitle}>
                <i className="bi bi-telegram text-black fs-3"></i>
              </TelegramShareButton>
            </div>
            {/* <BelowArticleThumbnails /> */}
          </article>
          <div className="article-sidebar mt-lg-5 ms-lg-5">
            <div className="mt-lg-5">
              <p className="fw-bold fs-5 mb-1">FOLLOW US</p>
              <div className="d-flex align-items-center gap-3">
                <a
                  href="https://www.facebook.com/notoriousmag"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="bi bi-facebook text-black fs-3"></i>
                </a>
                <a
                  href="https://twitter.com/notorious_mgzn"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="bi bi-twitter text-black fs-3"></i>
                </a>
                <a
                  href="https://www.instagram.com/notoriousmag/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="bi bi-instagram text-black fs-3"></i>
                </a>
                <a
                  href="https://www.youtube.com/@notorious-mag4705"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="bi bi-youtube text-black fs-3"></i>
                </a>
                <a
                  href="https://www.tiktok.com/@notorious.mag"
                  target="_blank"
                  rel="noreferrer"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="black"
                    viewBox="0 0 16 16"
                  >
                    <path d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3V0Z" />
                  </svg>
                </a>
              </div>
            </div>
            <div className="my-5">
              <p className="fw-bold fs-5 mb-1">SEARCH</p>
              <div className="input-group my-3 d-flex justify-content-md-start gap-2">
                <input
                  type="text"
                  className="form-control newsletter-input email-input rounded-0 border-1 border-black p-2"
                />
                <button
                  className="btn btn-dark rounded-0 mx-0"
                  type="button"
                  id="button-addon2"
                  onClick={handleClick}
                >
                  SEARCH
                </button>
              </div>
            </div>
            <div>
              <h2 className="fs-5 lh-1 mt-4 mb-4 text-md-start h-watching">
                Sign up to our <br />
                monthly newsletter
              </h2>
              <form
                action="https://app.racoon.email/lists/63ded88c0c6b8/embedded-form-subscribe-captcha"
                method="POST"
              >
                <div className="input-group my-3 d-flex justify-content-md-start gap-2">
                  <input
                    id="EMAIL"
                    type="text"
                    name="EMAIL"
                    className="form-control newsletter-input email-input rounded-0 border-1 border-black p-2"
                    placeholder="Enter your email here"
                  />
                  <button
                    className="btn btn-dark rounded-0 mx-0"
                    type="submit"
                    id="button-addon2"
                  >
                    SIGN UP
                  </button>
                </div>
              </form>
            </div>
            <div style={{ height: "200px", marginTop: "10px" }}>
              <div
                id="360vidDiv"
                style={{
                  backgroundColor: "#fffff",
                }}
              ></div>
            </div>

            <LargeRectangleAdSlot />
          </div>
        </div>
        <div>
          <img
            src="/img/brand/WatchingIsTheNewReading.svg"
            alt=""
            className="mb-2 text-img-watch"
          />
          <div className="row mb-3">
            <div className="mb-3 mb-md-0">
              <VideoSlider />
            </div>
          </div>
        </div>
      </div>
      {/* <div className="side-video">
        <div className="aplvideo"></div>
      </div> */}
    </Layout>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostById($id: String!) {
    post: wpPost(id: { eq: $id }) {
      id
      excerpt
      content
      title
      language {
        code
      }
      translations {
        uri
        language {
          code
        }
      }
      date(formatString: "MMMM DD, YYYY")
      featuredImage {
        node {
          altText
          localFile {
            childImageSharp {
              gatsbyImageData(
                quality: 100
                placeholder: TRACED_SVG
                layout: FULL_WIDTH
              )
            }
          }
        }
      }
      video {
        videoId
      }
      categories {
        nodes {
          name
          uri
        }
      }
    }
  }
`
